import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

import config from '@/config';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { APIProvider } from '@vis.gl/react-google-maps';
import Layout from './components/Layout';
import { KeycloakProvider } from './features/Keycloak/KeycloakContext';
import { queryClient } from './features/QueryClient/QueryClient';
import { allRoutes } from './features/Routes/Routes';
import hasPermission from './utils/permission.function';

const AppRoutes: React.FC = () => {
  const visibleRoutes = allRoutes.filter((route) => {
    return hasPermission(route.feature);
  });
  const defaultRoute = '/devices';
  return (
    <Routes>
      <Route element={<Layout />}>
        {visibleRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Route>
      <Route path="*" element={<Navigate to={defaultRoute} replace />} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <KeycloakProvider>
      <QueryClientProvider client={queryClient}>
        <APIProvider apiKey={config.googleMap.key}>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </APIProvider>
        <ReactQueryDevtools />
      </QueryClientProvider>
    </KeycloakProvider>
  );
};

export default App;
